import { Component, Injector, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { AuthService } from 'src/app/shared/services/auth-service/auth.service';
import { LocalStorageService } from 'src/app/shared/services/storage-service/local-storage.service';
import { RegexEnum } from 'src/app/shared/global/regex-enum';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MessagingService } from 'src/app/shared/services/messaging-service/messaging.service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-sign-in',
    templateUrl: './sign-in.component.html',
    styleUrls: ['./sign-in.component.scss'],
})
export class SignInComponent implements OnInit {
    public email!: string;
    form!: FormGroup;
    formObj: any;
    username!: string;
    password!: string;
    deviceInfo: any;
    userValidate: any;
    isDisable = false;
    private authService: AuthService;
    private deviceService: DeviceDetectorService;
    private messagingService: MessagingService;


    constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private ls: LocalStorageService,
    private toastrService: ToastrService,
    public injector: Injector,
    ) {
        this.deviceService = injector.get<DeviceDetectorService >(DeviceDetectorService);
        this.messagingService = injector.get<MessagingService >(MessagingService);
        this.authService = injector.get<AuthService >(AuthService);
    }
    userData: any[] = [];
    storeEncryptedID!: string;
    decrypt!: string;
    tempUserId: any;
    public showPassword = false;
    verifyUser!: boolean;
    device_token: any;
    ngOnInit(): void {
        this.messagingService.requestPermission();
        const val: any = localStorage.getItem('isUserLoggedIn');
        if (val == 'true') {
            this.router.navigate(['/']);
        }
        this.form = this.formBuilder.group({
            emailFormControl: [
                '',
                [
                    Validators.required,
                    Validators.minLength(5),
                    Validators.pattern(RegexEnum.email),
                ],
            ],
            pwdFormControl: ['', [Validators.required, Validators.minLength(6)]],
        });
        this.getSystemDetail();
        this.device_token = localStorage.getItem('fcm_token');
    }
    public togglePasswordVisibility(): void {
        this.showPassword = !this.showPassword;
    }

    async submit() {
        if (this.form.valid) {
            this.isDisable = true;
            this.username = this.form.controls['emailFormControl'].value;
            this.password = this.form.controls['pwdFormControl'].value;

            try {
                const data: any = await this.authService.login(
                    this.username,
                    this.password,
                    this.deviceInfo,
                    this.device_token
                );
                if (!data[0]) {
                    this.userValidate = true;
                    this.verifyUser = false;
                    this.isDisable = false;
                } else if (data[0] == 'error') {
                    this.verifyUser = true;
                    this.userValidate = false;
                } else {
                    this.verifyUser = false;
                    this.userData.push(data[1]);
                    this.tempUserId = this.userData[0].id;
                    if (this.tempUserId) {
                        this.storeEncryptedID = CryptoJS.AES.encrypt(
                            this.tempUserId?.toString()?.trim(),
                            ''
                        ).toString();
                    }
                    await localStorage.setItem('token', this.storeEncryptedID);
                    await this.ls.setDataInIndexedDB('token', this.storeEncryptedID);
                    await this.ls.setDataInIndexedDB('email', this.username);
                    if (data[1].profile_image) {
                        await this.ls.setDataInIndexedDB(
                            'userimagepath',
                            data[1].profile_image
                        );
                    }
                    await this.checkForVerifyUser();
                    this.userValidate = false;
                }

                if (data) this.isDisable = false;
                this.router.navigate(['/dashboard'])
            } catch (error) {
                this.isDisable = false; 
            }
        }
    }

    async checkForVerifyUser() {
        if (!this.userData[0].verification_token) {
            this.verifyUser = true;
        } else {
            this.router.navigate(['/dashboard'])
        }
    }

    getSystemDetail() {
        this.deviceInfo = this.deviceService.getDeviceInfo();
    }

    async resentVerifyEmail(){
        ((await this.authService.resentVerifyEmail(this.form.controls['emailFormControl'].value)).subscribe((res:any)=>{
            if(res?.message || res?.msg){
                this.toastrService.success(res.message || res?.msg);
            }
        }))

    }
}
